// 二级品牌馆配置 漫联元宇宙
export default {
  'ipbank.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800623000001641284385',
      storeName: '漫联元宇宙',
      microHost: 'ipbank-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800623000001641284385',
      storeName: '漫联元宇宙',
      microHost: 'ipbank-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800623000001641284385',
      storeName: '漫联元宇宙',
      microHost: 'ipbank-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800623000001641284385',
      storeName: '漫联元宇宙',
      microHost: 'ipbank-brand.ubanquan.cn'
    }
  }
};